import { Outlet } from 'react-router';
import type { FC } from 'react';

const UserPage: FC = () => <Outlet />;

export default UserPage;
